import React, { useState, useEffect, useCallback } from 'react';
import { Calendar, ChevronLeft, ChevronRight, X, Clock, MapPin, Edit, Trash2, AlertTriangle } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL || 'https://asistencia-backend.emarodri834.workers.dev/api';

export default function CalendarioAsistencia() {
  const [empleados, setEmpleados] = useState([]);
  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState('');
  const [marcajes, setMarcajes] = useState([]);
  const [descansos, setDescansos] = useState([]);
  const [mes, setMes] = useState(new Date().getMonth());
  const [año, setAño] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(false);
  
  const [modalAbierto, setModalAbierto] = useState(false);
  const [diaSeleccionado, setDiaSeleccionado] = useState(null);
  
  // ⬇️ NUEVO: Estados para edición
  const [editando, setEditando] = useState(null);
  const [formEdit, setFormEdit] = useState({
    fecha: '',
    hora: '',
    tipo: 'entrada'
  });

  const cargarEmpleados = async () => {
    try {
      const response = await fetch(`${API_URL}/admin/empleados/todos?estado=ACTIVO`);
      const data = await response.json();
      setEmpleados(data || []);
    } catch (error) {
      console.error('Error cargando empleados:', error);
    }
  };

  const cargarMarcajes = useCallback(async () => {
    if (!empleadoSeleccionado) return;
  
    try {
      setLoading(true);
    
      const primerDia = `${año}-${String(mes + 1).padStart(2, '0')}-01`;
      const ultimoDia = new Date(año, mes + 1, 0);
      const ultimoDiaStr = `${año}-${String(mes + 1).padStart(2, '0')}-${String(ultimoDia.getDate()).padStart(2, '0')}`;
    
      // ⬇️ NUEVO: Cargar marcajes con límite mayor y verificar datos
      const resMarcajes = await fetch(`${API_URL}/admin/marcajes?limit=1000`);
      const todosMarcajes = await resMarcajes.json();
    
      console.log('🔍 Total marcajes recibidos:', todosMarcajes.length);
      console.log('🔍 Empleado seleccionado:', empleadoSeleccionado);
      console.log('🔍 Periodo:', primerDia, 'a', ultimoDiaStr);
    
      // Filtrar solo los marcajes del empleado y periodo seleccionado
        const marcajesDelEmpleado = todosMarcajes.filter(m => {
        const coincideEmpleado = m.empleado_nombre === empleadoSeleccionado;
        const dentroDelPeriodo = m.fecha >= primerDia && m.fecha <= ultimoDiaStr;
      
        if (coincideEmpleado) {
          console.log('✅ Marcaje del empleado:', m.fecha, m.tipo, m.hora);
        }
      
        return coincideEmpleado && dentroDelPeriodo;
      });
    
      console.log('📋 Marcajes filtrados para este mes:', marcajesDelEmpleado.length);
      console.log('📋 Datos completos:', marcajesDelEmpleado);
    
      if (marcajesDelEmpleado.length > 0) {
        console.log('🔍 ESTRUCTURA DEL PRIMER MARCAJE:', marcajesDelEmpleado[0]);
        console.log('🔍 TODAS LAS PROPIEDADES:', Object.keys(marcajesDelEmpleado[0]));
      }
      
      setMarcajes(marcajesDelEmpleado);
    
      // Cargar descansos
      const empleado = empleados.find(e => e.nombre === empleadoSeleccionado);
      if (empleado) {
        const resDescansos = await fetch(
          `${API_URL}/admin/descansos?empleado_id=${empleado.id}&periodo_inicio=${primerDia}&periodo_fin=${ultimoDiaStr}`
        );
        const dataDescansos = await resDescansos.json();
        setDescansos(dataDescansos.descansos || []);
      }
    
    } catch (error) {
      console.error('❌ Error cargando datos:', error);
    } finally {
      setLoading(false);
    }
  }, [empleadoSeleccionado, mes, año, empleados]);

  useEffect(() => {
    cargarEmpleados();
  }, []);

  useEffect(() => {
    if (empleadoSeleccionado) {
      cargarMarcajes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empleadoSeleccionado, mes, año]);

  const abrirDetallesDia = (dia) => {
    const fechaDia = `${año}-${String(mes + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
    const marcajesDia = marcajes.filter(m => m.fecha === fechaDia);
    const descanso = descansos.find(d => d.fecha === fechaDia);
    
    setDiaSeleccionado({
      dia,
      fecha: fechaDia,
      marcajes: marcajesDia,
      descanso: descanso
    });
    setModalAbierto(true);
    setEditando(null);
  };

  // ⬇️ NUEVO: Función para iniciar edición
  const iniciarEdicion = (marcaje) => {
    setFormEdit({
      fecha: marcaje.fecha,
      hora: marcaje.hora,
      tipo: marcaje.tipo
    });
    setEditando(marcaje.id);
  };

  // ⬇️ NUEVO: Función para guardar edición
  const guardarEdicion = async (marcajeId) => {
    if (!window.confirm('¿Confirmas los cambios en este marcaje?')) {
      return;
    }

    try {
      const response = await fetch(`${API_URL}/admin/marcaje/${marcajeId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          fecha: formEdit.fecha,
          hora: formEdit.hora,
          tipo: formEdit.tipo,
          motivo: 'Editado desde calendario'
        })
      });

      if (response.ok) {
        alert('✅ Marcaje actualizado correctamente');
        setEditando(null);
        await cargarMarcajes();
        
        // Actualizar el modal
        const fechaDia = formEdit.fecha;
        const marcajesDia = marcajes.filter(m => m.fecha === fechaDia);
        setDiaSeleccionado({
          ...diaSeleccionado,
          marcajes: marcajesDia
        });
      } else {
        const error = await response.json();
        alert('❌ Error: ' + error.error);
      }
    } catch (error) {
      console.error('Error editando marcaje:', error);
      alert('Error de conexión');
    }
  };

  // ⬇️ NUEVO: Función para eliminar marcaje
  const eliminarMarcaje = async (marcajeId) => {
    const motivo = window.prompt('¿Por qué deseas eliminar este marcaje?');
    
    if (!motivo || !motivo.trim()) {
      return;
    }

    try {
      const response = await fetch(`${API_URL}/admin/marcaje/${marcajeId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ motivo: motivo.trim() })
      });

      if (response.ok) {
        alert('✅ Marcaje eliminado correctamente');
        await cargarMarcajes();
        
        // Actualizar el modal
        const marcajesActualizados = diaSeleccionado.marcajes.filter(m => m.id !== marcajeId);
        setDiaSeleccionado({
          ...diaSeleccionado,
          marcajes: marcajesActualizados
        });
      } else {
        const error = await response.json();
        alert('❌ Error: ' + error.error);
      }
    } catch (error) {
      console.error('Error eliminando marcaje:', error);
      alert('Error de conexión');
    }
  };

  const obtenerEstadoDia = (dia) => {
    const fechaDia = `${año}-${String(mes + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
    
    const descanso = descansos.find(d => d.fecha === fechaDia);
    
    if (descanso) {
      if (descanso.trabajado === 2) {
        return {
          tipo: 'descansado',
          color: 'bg-blue-500/30 border-blue-500',
          icono: '✅',
          texto: 'Descansado',
          entrada: null,
          salida: null,
          editado: false
        };
      } else if (descanso.trabajado === 1) {
        const marcajesDia = marcajes.filter(m => m.fecha === fechaDia);
        const entrada = marcajesDia.find(m => m.tipo === 'entrada');
        const salida = marcajesDia.find(m => m.tipo === 'salida');
        const hayEditados = marcajesDia.some(m => m.editado === 1);
        
        return {
          tipo: 'extra',
          color: 'bg-green-500/30 border-green-500',
          icono: '⭐',
          texto: 'Día Extra',
          entrada: entrada?.hora || null,
          salida: salida?.hora || null,
          editado: hayEditados
        };
      } else {
        return {
          tipo: 'programado',
          color: 'bg-yellow-500/30 border-yellow-500',
          icono: '📅',
          texto: 'Programado',
          entrada: null,
          salida: null,
          editado: false
        };
      }
    }
    
    const marcajesDia = marcajes.filter(m => m.fecha === fechaDia);
    
    if (marcajesDia.length === 0) {
      return {
        tipo: 'ausente',
        color: 'bg-red-500/20 border-red-500/50',
        icono: '❌',
        texto: 'Ausente',
        entrada: null,
        salida: null,
        editado: false
      };
    }
    
    const entrada = marcajesDia.find(m => m.tipo === 'entrada');
    const salida = marcajesDia.find(m => m.tipo === 'salida');
    const hayEditados = marcajesDia.some(m => m.editado === 1);
    
    if (entrada && salida) {
      return {
        tipo: 'completo',
        color: 'bg-green-500/30 border-green-500',
        icono: '✅',
        texto: 'Completo',
        entrada: entrada.hora,
        salida: salida.hora,
        editado: hayEditados
      };
    }
    
    return {
      tipo: 'incompleto',
      color: 'bg-yellow-500/30 border-yellow-500',
      icono: '⚠️',
      texto: entrada ? 'Sin salida' : 'Sin entrada',
      entrada: entrada?.hora || null,
      salida: salida?.hora || null,
      editado: hayEditados
    };
  };

  const formatearHora = (hora) => {
    if (!hora) return '';
    const [h, m] = hora.split(':');
    const hour = parseInt(h);
    const hour12 = hour % 12 || 12;
    const ampm = hour >= 12 ? 'PM' : 'AM';
    return `${hour12}:${m} ${ampm}`;
  };

  const cambiarMes = (direccion) => {
    if (direccion === 'anterior') {
      if (mes === 0) {
        setMes(11);
        setAño(año - 1);
      } else {
        setMes(mes - 1);
      }
    } else {
      if (mes === 11) {
        setMes(0);
        setAño(año + 1);
      } else {
        setMes(mes + 1);
      }
    }
  };

  const nombreMes = new Date(año, mes).toLocaleDateString('es-CO', { month: 'long', year: 'numeric' });
  const diasEnMes = new Date(año, mes + 1, 0).getDate();
  const primerDiaSemana = new Date(año, mes, 1).getDay();

  const dias = [];
  for (let i = 0; i < primerDiaSemana; i++) {
    dias.push(null);
  }
  for (let i = 1; i <= diasEnMes; i++) {
    dias.push(i);
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold mb-2">📅 Calendario de Asistencia</h2>
        <p className="opacity-80">Visualiza la asistencia diaria de tus empleados</p>
      </div>

      <div className="bg-white/5 rounded-xl border border-white/10 p-6 max-w-2xl">
        <label className="block mb-2 text-sm opacity-80">Selecciona empleado</label>
        <select
          value={empleadoSeleccionado}
          onChange={(e) => setEmpleadoSeleccionado(e.target.value)}
          className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white [&>option]:bg-slate-900 [&>option]:text-white"
        >
          <option value="" className="bg-slate-900 text-white">
            -- Selecciona un empleado --
          </option>
          {empleados.map((emp) => (
            <option key={emp.id} value={emp.nombre} className="bg-slate-900 text-white">
              {emp.nombre}
            </option>
          ))}
        </select>
      </div>

      {empleadoSeleccionado && (
        <>
          <div className="flex items-center justify-between bg-white/5 rounded-xl border border-white/10 p-4">
            <button
              onClick={() => cambiarMes('anterior')}
              className="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors"
            >
              <ChevronLeft className="w-5 h-5" />
              Anterior
            </button>
            <h3 className="text-2xl font-bold capitalize">{nombreMes}</h3>
            <button
              onClick={() => cambiarMes('siguiente')}
              className="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors"
            >
              Siguiente
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>

          <div className="bg-white/5 rounded-xl border border-white/10 p-4">
            <h4 className="font-semibold mb-3">Leyenda:</h4>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 text-sm">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-green-500/30 border border-green-500 rounded"></div>
                <span>✅ Completo</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-green-500/30 border border-green-500 rounded"></div>
                <span>⭐ Día Extra</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-yellow-500/30 border border-yellow-500 rounded"></div>
                <span>⚠️ Incompleto</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-yellow-500/30 border border-yellow-500 rounded"></div>
                <span>📅 Programado</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-blue-500/30 border border-blue-500 rounded"></div>
                <span>✅ Descansado</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-red-500/20 border border-red-500/50 rounded"></div>
                <span>❌ Ausente</span>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="bg-white/5 rounded-xl border border-white/10 p-12 text-center">
              <Calendar className="w-12 h-12 mx-auto mb-4 animate-spin" />
              <p>Cargando calendario...</p>
            </div>
          ) : (
            <div className="bg-white/5 rounded-xl border border-white/10 overflow-hidden">
              <div className="grid grid-cols-7 bg-white/10 text-center font-semibold">
                {['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'].map((dia) => (
                  <div key={dia} className="py-3 border-r border-white/10 last:border-r-0">
                    {dia}
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-7">
                {dias.map((dia, idx) => {
                  if (dia === null) {
                    return <div key={idx} className="aspect-square border-r border-b border-white/10"></div>;
                  }

                  const estado = obtenerEstadoDia(dia);

                  return (
                    <div
                      key={idx}
                      onClick={() => abrirDetallesDia(dia)}
                      className={`aspect-square border-r border-b border-white/10 p-2 ${estado.color} hover:opacity-80 transition-opacity cursor-pointer relative`}
                    >
                      {estado.editado && (
                        <div className="absolute top-1 right-1">
                          <Edit className="w-3 h-3 text-orange-400" />
                        </div>
                      )}
                      
                      <div className="text-lg font-bold mb-1">{dia}</div>
                      <div className="text-2xl mb-1">{estado.icono}</div>
                      <div className="text-xs font-semibold mb-1">{estado.texto}</div>
                      {estado.entrada && (
                        <div className="text-xs opacity-80">
                          E: {formatearHora(estado.entrada)}
                        </div>
                      )}
                      {estado.salida && (
                        <div className="text-xs opacity-80">
                          S: {formatearHora(estado.salida)}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </>
      )}

      {/* Modal de detalles */}
      {modalAbierto && diaSeleccionado && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
          <div className="bg-slate-800 rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto border border-white/20">
            <div className="sticky top-0 bg-slate-800 border-b border-white/10 p-6 flex justify-between items-center">
              <h3 className="text-2xl font-bold">
                📅 Detalles del {diaSeleccionado.dia} de {nombreMes.split(' ')[0]}
              </h3>
              <button
                onClick={() => setModalAbierto(false)}
                className="p-2 hover:bg-white/10 rounded-lg transition-colors"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="p-6 space-y-6">
              {diaSeleccionado.descanso && (
                <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4">
                  <h4 className="font-semibold text-blue-300 mb-2 flex items-center gap-2">
                    <Calendar className="w-5 h-5" />
                    Descanso Programado
                  </h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="opacity-70">Estado:</span>
                      <span className="font-semibold">
                        {diaSeleccionado.descanso.trabajado === 2 && '✅ Descansado'}
                        {diaSeleccionado.descanso.trabajado === 1 && '⭐ Trabajado (Extra)'}
                        {diaSeleccionado.descanso.trabajado === 0 && '📅 Programado'}
                      </span>
                    </div>
                    {diaSeleccionado.descanso.notas && (
                      <div>
                        <span className="opacity-70">Notas:</span>
                        <p className="mt-1">{diaSeleccionado.descanso.notas}</p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {diaSeleccionado.marcajes.length > 0 ? (
                <div>
                  <h4 className="font-semibold mb-3 flex items-center gap-2">
                    <Clock className="w-5 h-5" />
                    Marcajes del Día ({diaSeleccionado.marcajes.length})
                  </h4>
                  <div className="space-y-3">
                    {diaSeleccionado.marcajes.map((marcaje, idx) => (
                      <div
                        key={idx}
                        className={`bg-white/5 rounded-lg p-4 border ${
                          marcaje.editado === 1 
                            ? 'border-orange-500/50' 
                            : 'border-white/10'
                        }`}
                      >
                        {/* Header con tipo y botones */}
                        <div className="flex justify-between items-start mb-3">
                          <div>
                            <span className={`px-3 py-1 rounded-full text-sm ${
                              marcaje.tipo === 'entrada' 
                                ? 'bg-green-500/20 text-green-400' 
                                : 'bg-blue-500/20 text-blue-400'
                            }`}>
                              {marcaje.tipo.toUpperCase()}
                            </span>
                            {marcaje.editado === 1 && (
                              <span className="ml-2 text-orange-400 text-xs flex items-center gap-1 mt-1">
                                <Edit className="w-3 h-3" />
                                Editado
                              </span>
                            )}
                          </div>
                          
                          {/* ⬇️ NUEVO: Botones de acción */}
                          {editando !== marcaje.id && (
                            <div className="flex gap-2">
                              <button
                                onClick={() => iniciarEdicion(marcaje)}
                                className="p-2 bg-blue-500/20 hover:bg-blue-500/30 rounded-lg transition-colors"
                                title="Editar"
                              >
                                <Edit className="w-4 h-4 text-blue-400" />
                              </button>
                              <button
                                onClick={() => eliminarMarcaje(marcaje.id)}
                                className="p-2 bg-red-500/20 hover:bg-red-500/30 rounded-lg transition-colors"
                                title="Eliminar"
                              >
                                <Trash2 className="w-4 h-4 text-red-400" />
                              </button>
                            </div>
                          )}
                        </div>

                        {/* ⬇️ NUEVO: Modo edición */}
                        {editando === marcaje.id ? (
                          <div className="space-y-3">
                            <div className="grid grid-cols-2 gap-3">
                              <div>
                                <label className="block text-xs opacity-70 mb-1">Fecha</label>
                                <input
                                  type="date"
                                  value={formEdit.fecha}
                                  onChange={(e) => setFormEdit({ ...formEdit, fecha: e.target.value })}
                                  className="w-full bg-white/10 border border-white/20 rounded px-3 py-2 text-sm"
                                />
                              </div>
                              <div>
                                <label className="block text-xs opacity-70 mb-1">Hora</label>
                                <input
                                  type="time"
                                  value={formEdit.hora}
                                  onChange={(e) => setFormEdit({ ...formEdit, hora: e.target.value })}
                                  className="w-full bg-white/10 border border-white/20 rounded px-3 py-2 text-sm"
                                />
                              </div>
                            </div>
                            <div>
                              <label className="block text-xs opacity-70 mb-1">Tipo</label>
                              <select
                                value={formEdit.tipo}
                                onChange={(e) => setFormEdit({ ...formEdit, tipo: e.target.value })}
                                className="w-full bg-white/10 border border-white/20 rounded px-3 py-2 text-sm"
                              >
                                <option value="entrada">Entrada</option>
                                <option value="salida">Salida</option>
                              </select>
                            </div>
                            <div className="flex gap-2 pt-2">
                              <button
                                onClick={() => guardarEdicion(marcaje.id)}
                                className="flex-1 bg-green-500 hover:bg-green-600 py-2 rounded-lg text-sm font-semibold"
                              >
                                ✓ Guardar
                              </button>
                              <button
                                onClick={() => setEditando(null)}
                                className="flex-1 bg-red-500 hover:bg-red-600 py-2 rounded-lg text-sm font-semibold"
                              >
                                ✗ Cancelar
                              </button>
                            </div>
                          </div>
                        ) : (
                          <>
                            {/* Modo vista normal */}
                            <div className="grid grid-cols-2 gap-3 text-sm">
                              <div>
                                <span className="opacity-70">Hora:</span>
                                <div className="font-mono font-bold text-lg mt-1">
                                  {formatearHora(marcaje.hora)}
                                </div>
                              </div>
                              <div>
                                <span className="opacity-70">Distancia:</span>
                                <div className="font-semibold mt-1">
                                  {Math.round(marcaje.distancia_metros)}m
                                </div>
                              </div>
                            </div>

                            {/* ⬇️ NUEVO: Mostrar comentario del dispositivo si es MANUAL */}
                            {marcaje.dispositivo && marcaje.dispositivo.startsWith('MANUAL:') && (
                              <div className="mt-3 pt-3 border-t border-white/10">
                                <div className="flex items-start gap-2">
                                  <Edit className="w-4 h-4 text-blue-400 mt-0.5" />
                                  <div>
                                    <span className="opacity-70 text-xs">Comentario (Marcaje Manual):</span>
                                    <p className="text-sm mt-1">{marcaje.dispositivo.replace('MANUAL:', '').trim()}</p>
                                  </div>
                                </div>
                              </div>
                            )}
                            
                            {/* ⬇️ Mostrar motivo de edición/eliminación si existe */}
                            {marcaje.motivo_eliminacion && (
                              <div className="mt-3 pt-3 border-t border-white/10">
                                <div className="flex items-start gap-2">
                                  <AlertTriangle className="w-4 h-4 text-yellow-400 mt-0.5" />
                                  <div>
                                    <span className="opacity-70 text-xs">Motivo de edición:</span>
                                    <p className="text-sm mt-1">{marcaje.motivo_eliminacion}</p>
                                  </div>
                                </div>
                              </div>
                            )}
                            
                            <div className="mt-3 pt-3 border-t border-white/10 text-xs opacity-60">
                              <div className="flex items-center gap-1">
                                <MapPin className="w-3 h-3" />
                                <span>
                                  {marcaje.dispositivo && marcaje.dispositivo.startsWith('MANUAL:') 
                                    ? 'Marcaje Manual' 
                                    : `Dispositivo: ${marcaje.dispositivo?.substring(0, 30)}...`
                                  }
                                </span>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-8 text-center">
                  <div className="text-4xl mb-2">❌</div>
                  <p className="text-red-300 font-semibold">No hay marcajes registrados este día</p>
                </div>
              )}
            </div>

            <div className="sticky bottom-0 bg-slate-800 border-t border-white/10 p-4">
              <button
                onClick={() => setModalAbierto(false)}
                className="w-full bg-blue-500 hover:bg-blue-600 py-2 rounded-lg font-semibold transition-colors"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
